import axios from 'axios'
import { environment } from '@/data/environment/'

const getUserData = () => {
  return JSON.parse(atob(localStorage.getItem('uid')))
}

const isGeneralAdmin = () => {
  const roles = JSON.parse(localStorage.getItem('role') || '[]')
  return roles.includes('General-Admin') || roles.includes('General')
}

export default {
  namespaced: true,
  state: {
    statusGetChangeDate: null,
    statusSetChangeDate: null,
    changeDateConfig: [],
    changeDateConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setChangeDateConfig (state, data) {
      state.changeDateConfig = data
    },
    setResponseUpdateChangeDateConfig (state, data) {
      state.statusSetChangeDate = data
    },
    setResponseGetChangeDate (state, data) {
      state.statusGetChangeDate = data
    },
    setResponseChangeDateMsg (state, data) {
      state.changeDateConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getChangeDateConfig ({ commit }, data) {
      const userData = getUserData()
      const idCompania = !isGeneralAdmin() ? data.IdCompania : userData.idcompania
      const params = 'IdCompania=' + idCompania

      const endpoint = '/getChangeDateConfig?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setChangeDateConfig', response.data.respuesta.Datos[0])
            commit('setResponseGetChangeDate', false)
            commit('setResponseChangeDateMsg', 'Configuración de cambio de fecha consultada exitosamente.')
          } else {
            commit('setResponseGetChangeDate', true)
            commit('setResponseChangeDateMsg', response.data.respuesta.Mensaje || 'Hubo un error obteniendo la configuración de cambio de fecha. Inténtelo nuevamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetChangeDate', true)
          commit('setResponseChangeDateMsg', 'No pudo obtener configuración de cambio de fecha. Inténtelo nuevamente.')
          console.log(error.message)
        })
    },
    updateChangeDateConfig ({ commit }, data) {
      const endpoint = '/updateChangeDateConfig'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      const userData = getUserData()
      if (isGeneralAdmin()) {
        data.IdCompania = userData.idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          if (!response.data.respuesta.Error) {
            commit('setResponseUpdateChangeDateConfig', false)
            commit('setResponseChangeDateMsg', 'Configuración de cambio de fecha guardada exitosamente.')
          } else {
            commit('setResponseUpdateChangeDateConfig', true)
            commit('setResponseChangeDateMsg', response.data.respuesta.Mensaje || 'Hubo un error guardando la configuración de cambio de fecha. Inténtelo nuevamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseUpdateChangeDateConfig', true)
          commit('setResponseChangeDateMsg', 'No pudo guardar la configuración de cambio de fecha.')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateChangeDateConfig', data)
    },
    statusGetChangeDate ({ commit }, data) {
      commit('setResponseGetChangeDate', data)
    },
  },
}
